import { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Table, message, Tooltip } from 'antd';
import ReactJson from 'react-json-view';
import './index.less';
import * as api from '@/services/initial';
import { FullScreen } from '@/components';
import { getStatus, getDurationTime, formatTime, getRenderStatus } from '@/utils/utils';
let timerId1: any = null;
let timerId2: any = null;

const RenderDetails = () => {
  const { taskId } = useParams();
  const myRef = useRef<HTMLDivElement>({} as HTMLDivElement);
  const myRef2 = useRef<HTMLDivElement>({} as HTMLDivElement);
  const [detailObj, setDetailObj] = useState<any>();
  const [dataSource, setDataSource] = useState<TaskResultItemType[]>([]);
  const [logList, setLogList] = useState<LogItemType[]>([]);
  const [isShow, setShow] = useState<boolean>(false);
  useEffect(() => {
    getTaskDetails();
    return () => {
      clearTimeout(timerId1);
      clearTimeout(timerId2);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [taskId]);
  useEffect(() => {
    if (!!logList.length) {
      clearTimeout(timerId2);
      timerId2 = setTimeout(() => {
        myRef?.current?.scrollIntoView();
      }, 0);
    }
  }, [logList.length]);
  useEffect(() => {
    getLogByTaskId();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(detailObj)]);
  const getTaskDetails = async () => {
    const res = await api.getRenderTaskDetails(taskId as string);
    if (res?.success) {
      setDetailObj(res.data.details);
    }
  };

  const getLogByTaskId = async () => {
    const res = await api.getRenderLogByTaskId(taskId as string);
    if (res?.success) {
      setLogList(res.data?.details || []);
      if (res.data?.details?.status === 4) {
        clearTimeout(timerId1);
        timerId1 = setTimeout(() => {
          getLogByTaskId();
        }, 5000);
      } else {
        clearTimeout(timerId1);
        getTaskDetails();
      }
    }
  };

  const downloadFile = async (fileId: string) => {
    message.info('请稍等，正在导出文件');
    const res = await api.downoadRenderLogApi(fileId);
    if (res?.success) {
      const a = document.createElement('a');
      a.href = res?.data?.downloadUrl;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    }
  };

  const handleClick = (id: string) => {
    downloadFile(id);
  };
  const columns = [
    {
      title: '源类型',
      dataIndex: 'fileType',
      key: 'fileType',
    },
    {
      title: '目标类型',
      dataIndex: 'outputType',
      key: 'outputType',
    },
    {
      title: '状态',
      dataIndex: 'status',
      key: 'status',
    },
    {
      title: '创建时间',
      dataIndex: 'createAt',
      key: 'createAt',
    },
    {
      title: '操作',
      dataIndex: 'address',
      key: 'address',
      render: (_: any, row: TaskResultItemType) => {
        return (
          <div className="action-box">
            <span onClick={() => handleClick(row.storageFileId)}>下载</span>
          </div>
        );
      },
    },
  ];
  const handleTransfer = async (id: string) => {
    const res = await api.retryTransfer(id);
    if (res.success) {
      window.location.reload();
    } else {
      message.error('重新转换失败，请再次尝试');
    }
  };
  return (
    <div className="details-box">
      <div className="status-details">
        <div className="left">
          <div className="title">
            基本信息
            {detailObj?.logFileId && (
              <span className="action" onClick={() => handleClick(detailObj.logFileId)}>
                日志下载
              </span>
            )}
          </div>
          <div className="top">
            <div className="item">
              <span className="title">渲染方案名称:</span>
              <Tooltip title={detailObj?.itemName}>
                <span className="tip">{detailObj?.itemName}</span>
              </Tooltip>
            </div>
            <div className="item">
              <span className="title">渲染图开始时间:</span>
              <span className="tip">{formatTime(detailObj?.startRenderingTime)}</span>
            </div>
            <div className="item">
              <span className="title">渲染图结束时间:</span>
              <span className="tip">{formatTime(detailObj?.finishRenderingTime)}</span>
            </div>
            <div className="item">
              <span className="title">任务总耗时:</span>
              <span className="tip">
                {detailObj?.taskTotalCost}
              </span>
            </div>
            <div className="item">
              <span className="title">渲染方案id:</span>
              <span className="tip">{detailObj?.itemId}</span>
            </div>
            <div className="item">
              <span className="title">分辨率:</span>
              <span className="tip">{detailObj?.resolution}</span>
            </div>
            <div className="item">
              <span className="title">渲染图消息记录:</span>
              <span className="tip">{detailObj?.msg}</span>
            </div>
            <div className="item">
              <span className="title">渲染状态:</span>
              <span className="tip">{getRenderStatus(detailObj?.status)}</span>
            </div>
            <div className="item">
              <span className="title">渲染状态描述:</span>
              <span className="tip">{detailObj?.statusName}</span>
            </div>
            <div className="item">
              <span className="title">全景图id:</span>
              <span className="tip">{detailObj?.sceneId}</span>
            </div>
            <div className="item">
              <span className="title">全景图名称:</span>
              <span className="tip">{detailObj?.sceneName}</span>
            </div>
          </div>
        </div>
        <div
          className="right"
          ref={myRef2}
          onMouseEnter={() => setShow(true)}
          onMouseLeave={() => setShow(false)}
        >
          <div>
            {logList.map((log: LogItemType, index: number) => {
              if (index === logList.length - 1) {
                return (
                  <div key={index} ref={myRef}>
                    {log.msg}
                  </div>
                );
              } else {
                return <div key={index}>{log.msg}</div>;
              }
            })}
          </div>
          {(detailObj?.status === 4 || detailObj?.status === 0) && (
            <div className="loading-box">
              <div className="loading-item"></div>
              <div className="loading-item"></div>
              <div className="loading-item"></div>
              <div className="loading-item"></div>
              <div className="loading-item"></div>
            </div>
          )}
          {isShow && <FullScreen el={myRef2} customClass="custom-class" />}
        </div>
      </div>
    </div>
  );
};

export default RenderDetails;
